import React from 'react'

export const TemplateDeclarationContext = React.createContext({})

export const TemplateDeclarationConsumer = TemplateDeclarationContext.Consumer
